import { React, useEffect, useState, useContext } from "react";
import { MyContextProvider } from "../../../../../App";
import axios from "axios";
// import { API_URL } from "../../../../../Constant";
import {API_URL} from "../../../../../Constant/index";
import { GlobalLoading, showLoading } from "react-global-loading";
import { handleUserLevelAccessPermissions, validateRolesIIPHQ, shortMonthToFull } from "../../../../../Custom/Custom";
import { ToastContainer, toast } from "react-toastify";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
import { generateUBReport } from "../../ExportIIPExcel";
import iipTitleData from '../../../../../iip.json';
import iipFieldTitleData from '../../../../../titles.json';
import messages from '../../.././../../assets/Messages.json';
// import { changeDateFormat } from "../../../../../Custom/Custom";


const UBReport = () => {
  const [years, setYears] = useState([]);
  const [surveyYear, setSurveyYear] = useState([]);
  const [yearName, setYearName] = useState("");
  const [yearsName, setYearsName] = useState("");

  const [months, setMonths] = useState([]);
  const [monthName, setMonthName] = useState("");
  const [reportType, setReportType] = useState("");

  const [halfYearlyMonth, setHalfYearlyMonth] = useState("");
  const [quarterlyMonth, setQuarterlyMonth] = useState("");

  const [annualUBCategorisationReport, setAnnualUBCategorisationReport] = useState([]);
  const [buttonAccess, setButtonAccess] = useState({
    userLevel: "",
    roles: "",
    isVisible: false,
  });
  const [yearNameNextTitle, setYearNameNextTitle] = useState([]);
  const token = useContext(MyContextProvider).token;
  const decode_token = jwtDecode(token);
  const navigate = useNavigate();
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };


  const storedLanguage = localStorage.getItem('language');



  const getAllYears = () => {
    const currentYear = new Date().getFullYear();
    const yearsArray = [];
    for (let year = currentYear; year >= 2021; year--) {
      yearsArray.push(year);
    }
    return yearsArray;
  };


  //get next Years 
  const getNextYear = (year) => {
    const nextYear = parseInt(year) + 1;
    return `${year}-${nextYear}`;
  };


  const getSurveyYear = () => {
    const now = new Date();
    const currentYear = now.getFullYear();
    const currentMonth = now.getMonth(); 
    const currentFinancialYearStart = currentMonth < 3 ? currentYear - 1 : currentYear;
    
    const yearsArray = [];
    for (let year = currentFinancialYearStart; year >= 2021; year--) {
      yearsArray.push(year);
    }
    return yearsArray;
  };

  const getMonthsList = () => {
    showLoading(true);
    axios
      .get(`${API_URL}api/graph/getMonths/2019`, config)
      .then((res) => {
        let monthDataResponse = res.data;
        console.warn("PPPPPPPPP", monthDataResponse);

        if (monthDataResponse.status) {
          const monthList = monthDataResponse.data.map(item => item.MONTH);
          setMonths(monthList);

        }
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        showLoading(false);
      });
  };

  const getReportTypes = () => [
    { value: "Annual", label: "Annual Report" },
    { value: "Nine_Months", label: "Nine Month Report" },
    { value: "Half-Yearly", label: "Half Yearly Report" },
    { value: "Quarterly", label: "Quarterly Report" },
    { value: "Monthly", label: "Monthly Report" },
  ];


  //Half Yearly Report Month 

  const getHalfYearlyMonth = () => [
    { value: "Apr-Sep", label: "Apr-Sep" },
    { value: "Oct-Mar", label: "Oct-Mar" },
  ];


  //Quarterly Report Month

  const getQuarterlyMonth = () => [
    { value: "Apr-Jun", label: "Apr-Jun" },
    { value: "Jul-Sep", label: "Jul-Sep" },
    { value: "Oct-Dec", label: "Oct-Dec" },
    { value: "Jan-Mar", label: "Jan-Mar" }
  ];


  useEffect(() => {
    const level = handleUserLevelAccessPermissions(decode_token);
    setButtonAccess(level);
    const getYearList = () => {
      setYears(getAllYears());
    };

    const getSurveyYearList = () => {
      setSurveyYear(getSurveyYear());
    };

    const userRole = async () => {
      showLoading(true);
      try {
        const role = await validateRolesIIPHQ(decode_token);
        if (role) {
          getYearList();
          getSurveyYearList();
          getMonthsList();
          getReportTypes();
          getHalfYearlyMonth();

        } else {
          alert(
            "You are not an authorized for IIP Report."
          );
          navigate("/dashboard");
        }
      } catch (error) {
        console.log(error);
        showLoading(false);
      } finally {
        showLoading(false);
      }
    };

    userRole();
  }, []);


  const handleYearChange = (e) => {
    setYearName(e.target.value);
  };


  const handleSurveyYearsChange = (e) => {
    setYearsName(e.target.value);
  };

  const handleMonthChange = (e) => {
    setMonthName(e.target.value);
  };

  const formatIndexToFixed2 = (val) => {
    if (val === '' || val == null) return '';
    const n = Number(val);
    return Number.isNaN(n) ? String(val) : n.toFixed(2);
  };

  const withFixedIndexFields = (item) => ({
    ...item,
    IndexI: formatIndexToFixed2(item.index ?? item.IndexI),
    IndexWt: formatIndexToFixed2(item.index_wt ?? item.IndexWt),
  });

  const fetchReportData = async (postData) => {
    showLoading(true);
    try {
      const endpoint = `${API_URL}api/iipReports/IIPUBReport`;
      const response = await axios.post(endpoint, postData, config);

      // API returns data.current & data.previousYear; fallback to flat data for older API
      const dataSource = response.data.data?.current ?? response.data.data;
      const majorList = dataSource?.MajorReportDataList;
      const totalDataRaw = dataSource?.totalData || [];

      let allData = Array.isArray(majorList)
        ? majorList
            .reduce((acc, data) => acc.concat(data.items || []), [])
            .map(withFixedIndexFields)
        : [];

      const mapTotalData = (raw) => (raw || []).map(item => ({
        Nic5d: item.Nic5d ?? item.nic2d,
        nic2d: item.nic2d ?? item.Nic5d,
        ItemName: item.item_name ?? item.ItemName,
        Weight: item.weight ?? item.Weight,
        unitName: item.unitName ?? '',
        IndexI: formatIndexToFixed2(item.index ?? item.IndexI),
        IndexWt: formatIndexToFixed2(item.index_wt ?? item.IndexWt),
      }));

      const totalData = mapTotalData(totalDataRaw);
      const currentList = [...allData, ...totalData];

      const prevSource = response.data.data?.previousYear;
      let previousList = null;
      const isAnnualReport = postData.reportType === 'Annual';
      if (isAnnualReport && prevSource && Array.isArray(prevSource.MajorReportDataList)) {
        const prevAll = prevSource.MajorReportDataList
          .reduce((acc, data) => acc.concat(data.items || []), [])
          .map(withFixedIndexFields);
        previousList = [...prevAll, ...mapTotalData(prevSource.totalData)];
      }

      // Monthly: current + previousMonth + previousYear (11 columns)
      const prevMonthSource = response.data.data?.previousMonth;
      let prevMonthList = null;
      let prevYearListMonthly = null;
      const isMonthlyReport = postData.reportType === 'Monthly';
      if (isMonthlyReport && prevMonthSource && Array.isArray(prevMonthSource.MajorReportDataList)) {
        const pmAll = prevMonthSource.MajorReportDataList
          .reduce((acc, data) => acc.concat(data.items || []), [])
          .map(withFixedIndexFields);
        prevMonthList = [...pmAll, ...mapTotalData(prevMonthSource.totalData)];
      }
      if (isMonthlyReport && prevSource && Array.isArray(prevSource.MajorReportDataList)) {
        const pyAll = prevSource.MajorReportDataList
          .reduce((acc, data) => acc.concat(data.items || []), [])
          .map(withFixedIndexFields);
        prevYearListMonthly = [...pyAll, ...mapTotalData(prevSource.totalData)];
      }

      const useMonthlyComparison = isMonthlyReport && prevMonthList != null && prevYearListMonthly != null
        && prevMonthList.length === currentList.length && prevYearListMonthly.length === currentList.length;

      if (response.data.status) {
        if (currentList.length > 0 || totalData.length > 0) {
          setAnnualUBCategorisationReport(currentList);
          const usePreviousYear = isAnnualReport && previousList != null && previousList.length === currentList.length;
          let merged;
          if (useMonthlyComparison) {
            const cv = (v) => (v !== undefined && v !== null ? v : '');
            merged = currentList.map((cur, i) => {
              const pm = prevMonthList[i];
              const py = prevYearListMonthly[i];
              return [
                cv(cur.Nic5d), cv(cur.nic2d), cv(cur.ItemName), cv(cur.Weight), cv(cur.unitName),
                cv(cur.IndexI), cv(cur.IndexWt),
                cv(pm?.IndexI), cv(pm?.IndexWt),
                cv(py?.IndexI), cv(py?.IndexWt)
              ];
            });
          } else if (usePreviousYear) {
            merged = currentList.map((cur, i) => {
              const prev = previousList[i];
              const cv = (v) => (v !== undefined && v !== null ? v : '');
              return [
                cv(cur.Nic5d), cv(cur.nic2d), cv(cur.ItemName),
                cv(cur.Weight), cv(cur.unitName), cv(cur.IndexI), cv(cur.IndexWt),
                cv(prev?.IndexI), cv(prev?.IndexWt)
              ];
            });
          } else {
            merged = currentList.map(item => [
              item.Nic5d ?? '', item.nic2d ?? '', item.ItemName ?? '',
              item.Weight ?? '', item.unitName ?? '', item.IndexI ?? '', item.IndexWt ?? ''
            ]);
          }
          const monthLabelFromReport = (reportNameOrDate, fromDate) => {
            // fromDate is YYYY-MM-DD → show "Jan-2026", "Dec-2025", "Jan-2025"
            if (fromDate && /^\d{4}-\d{2}-\d{2}$/.test(fromDate)) {
              const parts = fromDate.split('-');
              const year = parts[0];
              const monthNum = parseInt(parts[1], 10);
              const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
              return `${months[monthNum - 1]}-${year}`;
            }
            if (reportNameOrDate && /([A-Za-z]{3,4})-(\d{4})/i.test(reportNameOrDate)) {
              const match = reportNameOrDate.match(/([A-Za-z]{3,4})-(\d{4})/i);
              const mon = match[1].charAt(0).toUpperCase() + match[1].slice(1, 3).toLowerCase();
              return `${mon}-${match[2]}`;
            }
            return reportNameOrDate || '';
          };
          const dataCurrent = response.data.data?.current;
          return {
            reportData: merged,
            hasPreviousYear: usePreviousYear,
            previousYearReportName: usePreviousYear ? prevSource?.reportName || null : null,
            hasMonthlyComparison: useMonthlyComparison,
            currentMonthLabel: useMonthlyComparison && dataCurrent ? monthLabelFromReport(dataCurrent.reportName, dataCurrent.fromDate) : null,
            previousMonthLabel: useMonthlyComparison && prevMonthSource ? monthLabelFromReport(prevMonthSource.reportName, prevMonthSource.fromDate) : null,
            previousYearLabelMonthly: useMonthlyComparison && prevSource ? monthLabelFromReport(prevSource.reportName, prevSource.fromDate) : null,
          };
        } else {
          console.warn('No data found for the specified parameters.');
          toast.info('No data found for the specified parameters.');
        }
      } else {
        console.error('Error in API response:', response.data.message);
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error('Error fetching data:', error.message);
      toast.error('An error occurred while fetching data.');
    } finally {
      showLoading(false);
    }
    return { reportData: [], hasPreviousYear: false, previousYearReportName: null };
  };




  const handleGenerateExcel = async () => {
    const yearForRequest = reportType === 'Monthly' ? yearName : yearsName;
    if (!yearForRequest) {
      toast.error('Please select a year.', messages.COLOR_RED);
      return;
    }

    if (reportType === 'Monthly' && !monthName) {
      toast.error('Please select a month.', messages.COLOR_RED);
      return;
    }
    if (reportType === 'Half-Yearly' && !halfYearlyMonth) {
      toast.error('Please select a half-yearly month.', messages.COLOR_RED);
      return;
    }
    if (reportType === 'Quarterly' && !quarterlyMonth) {
      toast.error('Please select a quarterly month.', messages.COLOR_RED);
      return;
    }

    const postData = {
      reportType: reportType,
      Year: yearForRequest,
      ...(reportType === 'Half-Yearly' ? { monthDuration: halfYearlyMonth } : {}),
      ...(reportType === 'Quarterly' ? { monthDuration: quarterlyMonth } : {}),
      ...(reportType === 'Monthly' ? { month: monthName } : {}),
    };

    const result = await fetchReportData(postData);
    const reportData = result.reportData || [];

    if (reportData.length > 0) {


      let excelFileName = `IIPUBReport_${reportType}`;

      if (reportType === 'Monthly') {
        excelFileName += `_${monthName}_${yearForRequest}`;
      } else if (reportType === 'Half-Yearly') {
        excelFileName += `_(${halfYearlyMonth})`;
      } else if (reportType === 'Quarterly') {
        excelFileName += `_(${quarterlyMonth})`;
      } else {
        excelFileName = `IIPUBReport_${reportType}`;
      }

      let fifthRowText = '';

      switch (reportType) {
        case 'Monthly':
          fifthRowText = `Monthly Report - ${monthName} (${yearName})`;
          break;
        case 'Half-Yearly':
          fifthRowText = `Half-Yearly Report - ${halfYearlyMonth} (${yearsName} - ${parseInt(yearsName) + 1})`;
          break;
        case 'Quarterly':
          fifthRowText = `Quarterly Report - ${quarterlyMonth} (${yearsName} - ${parseInt(yearsName) + 1})`;
          break;
        case 'Annual':
          fifthRowText = `Annual Report - (${yearsName} - ${parseInt(yearsName) + 1})`;
          break;
        case 'Nine_Months':
          fifthRowText = `Nine Months Report - (${yearsName} - ${parseInt(yearsName) + 1})`;
          break;
        default:
          fifthRowText = `Report - ${yearsName}`;
          break;
      }

      function getCurrentDateTime() {
        const now = new Date();

        const month = (now.getMonth() + 1).toString().padStart(2, '0');
        const day = now.getDate().toString().padStart(2, '0');
        const year = now.getFullYear();

        const hours = now.getHours().toString().padStart(2, '0');
        const minutes = now.getMinutes().toString().padStart(2, '0');
        const seconds = now.getSeconds().toString().padStart(2, '0');

        return `${month}/${day}/${year}, ${hours}:${minutes}:${seconds}`;
      }

      const isMonthlyWithComparison = result.hasMonthlyComparison === true;
      const mergeEnd = isMonthlyWithComparison ? 'K' : (result.hasPreviousYear ? 'I' : 'G');
      const headerCols = isMonthlyWithComparison
        ? ['NIC-5d', 'NIC-2d', 'Item Name', 'Weight', 'Units', 'Index(I)', 'Index* Wt', 'Index(I)', 'Index* Wt', 'Index(I)', 'Index* Wt']
        : result.hasPreviousYear
          ? ['NIC-5d', 'NIC-2d', 'Item Name', 'Weight', 'Units', 'Index(I)', 'Index* Wt', 'Index(I)', 'Index* Wt']
          : ['NIC-5d', 'NIC-2d', 'Item Name', 'Weight', 'Units', 'Index(I)', 'Index* Wt'];

      let excelObjectData = {
        fileName: excelFileName,
        reportType: excelFileName,
        fileType: 'xls',
        sheetName: "IIPUBReport",
        firstRowMergeCells: `A1:${mergeEnd}1`,
        firstRowExportData: getCurrentDateTime(),
        firstRowCellNumber: 11,
        secondRowMergeCells: `A2:${mergeEnd}2`,
        secondRowText: 'ECONOMICS & STATISTICS DIVISION, UTTAR PRADESH',
        thirdRowMergeCells: `A3:${mergeEnd}3`,
        thirdRowText: 'INDUSTRIAL PRODUCTION INDEX  U.P',
        fourthRowMergeCells: `A4:${mergeEnd}4`,
        fourthRowText: "USED BASED CATEGORISATION (BASE YEAR 2011-12)",
        fifthRowMergeCells: `A5:${mergeEnd}5`,
        fifthRowText: fifthRowText,
        headerEnglishColumns: headerCols,
        excelRowData: reportData.map(row => (Array.isArray(row) ? row : [
          row.Nic5d, row.nic2d, row.ItemName, row.Weight, row.unitName, row.IndexI, row.IndexWt
        ])),
        hasPreviousYear: result.hasPreviousYear || false,
        previousYearReportName: result.previousYearReportName || null,
        previousYearHighlightColor: 'FFE4B5',
        ...(result.hasPreviousYear && !isMonthlyWithComparison && {
          currentYearLabel: `${yearsName}-${parseInt(yearsName) + 1}`,
          previousYearLabel: result.previousYearReportName || `${parseInt(yearsName) - 1}-${yearsName}`,
        }),
        hasMonthlyComparison: isMonthlyWithComparison,
        ...(isMonthlyWithComparison && {
          currentMonthLabel: result.currentMonthLabel,
          previousMonthLabel: result.previousMonthLabel,
          previousYearLabelMonthly: result.previousYearLabelMonthly,
          previousMonthHighlightColor: 'ADD8E6', // light blue
        }),
      };
      generateUBReport(excelObjectData);
    }
  };

  const handleReportTypeChange = (e) => {
    const selectedReportType = e.target.value;
    setReportType(selectedReportType);
    setMonthName("");
    setYearName("");
    setHalfYearlyMonth("");
    setQuarterlyMonth("");
  };

  return (
    <>
      <GlobalLoading />
      <ToastContainer />
      <div className="container-fluid py-3">
        <div className="card mx-3 mb-3">
          <div className="card-body pb-1">
            <div className="row align-items-center">
              <h4 className="page_heading">
                <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? iipTitleData.hi.USED_BASED_REPORT : iipTitleData.en.USED_BASED_REPORT }} />
              </h4>

              <div className="row align-items-center">
                <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                  <label className="fw-bold h6">Report Type</label>
                  <select
                    name="report_type"
                    className="form-select"
                    onChange={handleReportTypeChange}
                    value={reportType}
                  >
                    <option value="" disabled>Select Report Type</option>
                    {getReportTypes().map((type, index) => (
                      <option key={index} value={type.value}>{type.label}</option>
                    ))}
                  </select>
                </div>

                {reportType === "Monthly" && (
                  <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                    <label className="fw-bold h6">Year</label>
                    <select
                      name="year_name"
                      className="form-select"
                      onChange={handleYearChange}
                      value={yearName}
                    >
                      <option value="" disabled>Select Year</option>
                      {years &&
                        years.map((ele, index) => (
                          <option key={index} value={ele}>
                            {ele}
                          </option>
                        ))}
                    </select>
                  </div>
                )}

                {(reportType === "Annual" || reportType === "Nine_Months") && (
                  <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                    <label className="fw-bold h6">Select Year</label>
                    <select
                      name="year_name"
                      className="form-select"
                      onChange={handleSurveyYearsChange}
                      value={yearsName}
                    >
                      <option value="" disabled>Select Year</option>
                      {surveyYear &&
                        surveyYear.map((ele, index) => (
                          <option key={index} value={ele}>
                            {getNextYear(ele)}
                          </option>
                        ))}
                    </select>
                  </div>
                )}

                {reportType === "Half-Yearly" && (
                  <>
                    <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                      <label className="fw-bold h6">Select Year</label>
                      <select
                        name="year_name"
                        className="form-select"
                        onChange={handleSurveyYearsChange}
                        value={yearsName}
                      >
                        <option value="" disabled>Select Year</option>
                        {surveyYear &&
                          surveyYear.map((ele, index) => (
                            <option key={index} value={ele}>
                              {getNextYear(ele)}
                            </option>
                          ))}
                      </select>
                    </div>

                    <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                      <label className="fw-bold h6">Select Month</label>
                      <select
                        name="half_yearly_month"
                        className="form-select"
                        onChange={(e) => setHalfYearlyMonth(e.target.value)}
                        value={halfYearlyMonth}
                      >
                        <option value="" disabled>Select Month</option>
                        {getHalfYearlyMonth().map((type, index) => (
                          <option key={index} value={type.value}>{type.label}</option>
                        ))}
                      </select>
                    </div>
                  </>
                )}

                {reportType === "Quarterly" && (
                  <>
                    <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                      <label className="fw-bold h6">Select Year</label>
                      <select
                        name="year_name"
                        className="form-select"
                        onChange={handleSurveyYearsChange}
                        value={yearsName}
                      >
                        <option value="" disabled>Select Year</option>
                        {surveyYear &&
                          surveyYear.map((ele, index) => (
                            <option key={index} value={ele}>
                              {getNextYear(ele)}
                            </option>
                          ))}
                      </select>
                    </div>

                    <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                      <label className="fw-bold h6">Select Month Quarter</label>
                      <select
                        name="quarterly_month"
                        className="form-select"
                        onChange={(e) => setQuarterlyMonth(e.target.value)}
                        value={quarterlyMonth}
                      >
                        <option value="" disabled>Select Month</option>
                        {getQuarterlyMonth().map((type, index) => (
                          <option key={index} value={type.value}>{type.label}</option>
                        ))}
                      </select>
                    </div>
                  </>
                )}

                {reportType === "Monthly" && (
                  <>
                    <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                      <label className="fw-bold h6">Month</label>
                      <select
                        name="month_name"
                        className="form-select"
                        onChange={handleMonthChange}
                        value={monthName}
                      >
                        <option value="" disabled>Select Month</option>
                        {months &&
                          months.map((ele, index) => (
                            <option key={index} value={ele}>
                              {shortMonthToFull(ele)}
                            </option>
                          ))}
                      </select>
                    </div>
                  </>
                )}

                {(reportType === "Annual" || reportType === "Nine_Months" || reportType === "Half-Yearly" || reportType === "Quarterly" || reportType === "Monthly") && (
                  <div className="col-xl-2 col-lg-12 mb-3">
                    <label className="w-100 d-none d-sm-block">&nbsp;</label>
                    <button onClick={handleGenerateExcel} className="btn btn_orange">Get Report</button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};


export default UBReport